export const PUSH_POPUP = () => 'PUSH_POPUP';
export const POP_POPUP = () => 'POP_POPUP';
